import type { FilePrepareResponseDatagramBuf } from "~/classes/generated/response"

const _console = useLogger("file/prepare")

/** Parse a Flatbuffers representation of a response */
export function handleFilePrepareResponseDatagramBuf(
  _datagram: FilePrepareResponseDatagramBuf,
) {
  throw new Error("The client should never receive a prepare response")
}
